<h5 class="mt-2 mb-5">{{ title }}</h5>
<div class="container-fluid">

  <div class="timeline overflow-auto">
    <div class="events">
      <!-- Data de Exercício -->
      <div class="event event-start">
        <div class="event-top"></div>
        <div class="circle circle-start fas fa-calendar-alt"></div>
        <div class="event-bottom">
          <p class="event-label"> {{ dataPosse ? 'Data de Posse' : 'Data de Exercício' }} </p>
          <p class="event-date">{{ (dataPosse || dadosTimeline?.dataAdmissao) | date:'dd/MM/yyyy' }}</p>
        </div>
      </div>

      <!-- Loop dinâmico para PGDIs e TERMOs -->
      <ng-container *ngFor="let pgdi of dadosTimeline?.pgdis; let i = index">
        <!-- PGDI -->
        <div class="event">
          <div class="event-top">
            <p class="event-label">{{ getOrdinalLabel(i + 1) }} PGDI</p>
            <button class="btn btn-sm" [ngClass]="getColorButtonByStatus(pgdi?.status)">
              <span>{{ pgdi?.status || 'Pendente' }}</span>
            </button>
          </div>
          <div class="circle" [ngClass]="{'circle-active': pgdi?.status === 'Finalizado', 'circle-andamento': pgdi?.status === 'Andamento'}"></div>
          <div class="event-bottom"></div>
        </div>

        <!-- TERMO correspondente -->
        <div class="event" *ngIf="getTermo(i)">
          <div class="event-top"></div>
          <div class="circle" [ngClass]="{'circle-active': getTermo(i)?.status === 'Finalizado', 'circle-andamento': getTermo(i)?.status === 'Andamento'}"></div>
          <div class="event-bottom">
            <p class="event-label">{{ getOrdinalLabel(i + 1) }} TERMO</p>
            <button class="btn btn-sm" [ngClass]="getColorButtonByStatus(getTermo(i)?.status)">
              <span>{{ getTermo(i)?.status || 'Pendente' }}</span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Parecer Conclusivo -->
      <div class="event event-end">
        <div class="event-top">
          <p class="event-label">Parecer Conclusivo</p>
          <button class="btn btn-sm" [ngClass]="getColorButtonByStatus(getParecer()?.status)">
            <span>{{ getParecer()?.status || 'Pendente' }}</span>
          </button>
        </div>
        <div class="circle" [ngClass]="{'circle-active': getParecer()?.status === 'Finalizado', 'circle-andamento': getParecer()?.status === 'Andamento'}"></div>
        <div class="event-bottom"></div>
      </div>

      <div class="line"></div>

       <!-- Legenda de Status -->
      </div>
    </div>
  </div>
  <hr/>
  <div class="status-legend">
    <h6 class="legend-title">Legenda de Status</h6>
    <div class="legend-items">
      <div class="legend-item">
        <span class="legend-circle legend-pendente"></span>
        <span class="legend-text">Pendente</span>
      </div>
      <div class="legend-item">
        <span class="legend-circle legend-andamento"></span>
        <span class="legend-text">Andamento</span>
      </div>
      <div class="legend-item">
        <span class="legend-circle legend-finalizado"></span>
        <span class="legend-text">Finalizado</span>
      </div>
    </div>
  </div>
